import { apiFetch } from './http';

export interface AccountUser {
  id: string;
  email: string;
  name: string | null;
}

export type SignInMethod = 'google' | 'github' | 'email';

export const authApi = {
  me: () => apiFetch<{ user: AccountUser | null }>('/me').then((r) => r.user),
  methods: () => apiFetch<{ methods: SignInMethod[] }>('/auth/methods').then((r) => r.methods),
  requestMagicLink: (email: string, locale: string, returnTo: string) =>
    apiFetch<undefined>('/auth/magic/request', {
      method: 'POST',
      json: { email, locale, returnTo },
    }),
  verifyMagicLink: (token: string) =>
    apiFetch<{ returnTo: string }>('/auth/magic/verify', { method: 'POST', json: { token } }),
  logout: () => apiFetch<undefined>('/auth/logout', { method: 'POST' }),
  /** Full-page navigation to an OAuth provider. */
  oauthStartUrl: (provider: 'google' | 'github', returnTo: string) =>
    `/api/auth/${provider}/start?returnTo=${encodeURIComponent(returnTo)}`,
};
